import script from "./TheProductsReport.vue?vue&type=script&setup=true&lang=js"
export * from "./TheProductsReport.vue?vue&type=script&setup=true&lang=js"

import "./TheProductsReport.vue?vue&type=style&index=0&id=073467ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073467ed"]])

export default __exports__